import { render } from "./AppMenuItem.vue?vue&type=template&id=c64e4e92&scoped=true"
import script from "./AppMenuItem.vue?vue&type=script&lang=js"
export * from "./AppMenuItem.vue?vue&type=script&lang=js"

import "./AppMenuItem.vue?vue&type=style&index=0&id=c64e4e92&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c64e4e92"]])

export default __exports__